export const initialPosFirstItem = 40;
export const initialPosSecondItem = 60;
export const initialPosThirdItem = 80;
